import type { DefaultValues } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';

import type { ILogInFormValues } from '~/components/forms/LogInForm';
import type { IAppRegion } from '~/lib/appSettings';
import { NewSessionPage } from '~/components/pages/NewSessionPage';
import { PageTemplate } from '~/components/templates/PageTemplate';

export const NewSessionRoute: React.FC = () => {
  const [searchParams] = useSearchParams();
  const appRegion = (searchParams.get('appRegion') || undefined) as
    | IAppRegion
    | undefined;
  const defaultValues: DefaultValues<ILogInFormValues> = {
    appRegion,
  };

  return (
    <PageTemplate>
      <NewSessionPage
        defaultValues={defaultValues}
        nextUrl={searchParams.get('nextUrl') ?? undefined}
      />
    </PageTemplate>
  );
};
